import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/mexico.geojson";

const REGIONS = [
    { code: "Aguascalientes", name: "Aguascalientes" },
    { code: "Baja California", name: "Baja California" },
    { code: "Baja California Sur", name: "Baja California Sur" },
    { code: "Campeche", name: "Campeche" },
    { code: "Chiapas", name: "Chiapas" },
    { code: "Chihuahua", name: "Chihuahua" },
    { code: "Coahuila de Zaragoza", name: "Coahuila de Zaragoza" },
    { code: "Colima", name: "Colima" },
    { code: "Distrito Federal", name: "Distrito Federal" },
    { code: "Durango", name: "Durango" },
    { code: "Guanajuato", name: "Guanajuato" },
    { code: "Guerrero", name: "Guerrero" },
    { code: "Hidalgo", name: "Hidalgo" },
    { code: "Jalisco", name: "Jalisco" },
    { code: "Michoacán de Ocampo", name: "Michoacán de Ocampo" },
    { code: "Morelos", name: "Morelos" },
    { code: "México", name: "México" },
    { code: "Nayarit", name: "Nayarit" },
    { code: "Nuevo León", name: "Nuevo León" },
    { code: "Oaxaca", name: "Oaxaca" },
    { code: "Puebla", name: "Puebla" },
    { code: "Querétaro", name: "Querétaro" },
    { code: "Quintana Roo", name: "Quintana Roo" },
    { code: "San Luis Potosí", name: "San Luis Potosí" },
    { code: "Sinaloa", name: "Sinaloa" },
    { code: "Sonora", name: "Sonora" },
    { code: "Tabasco", name: "Tabasco" },
    { code: "Tamaulipas", name: "Tamaulipas" },
    { code: "Tlaxcala", name: "Tlaxcala" },
    { code: "Veracruz de Ignacio de la Llave", name: "Veracruz de Ignacio de la Llave" },
    { code: "Yucatán", name: "Yucatán" },
    { code: "Zacatecas", name: "Zacatecas" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const MexicoMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 1100, center: [-102, 23] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="mexico"
            analyticsLocationType="mexico"
            trackingLabel="Mexico Map"
            storageKey="mexico_map"
            title="🇲🇽 Mexico Travel Map"
            subtitle="Click on Mexican states you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="States"
            unitLabel="states"
            captionUnit="Mexican states"
            share={{
                region: 'Mexico',
                fileName: 'visited-mexico-map.png',
                trackId: 'mexico'
            }}
            renderMap={renderMap}
        />
    );
};

export default MexicoMapSection;
